import React from 'react';
import { Helmet } from 'react-helmet';

const VisualVisitor = props => {
  return (
    <React.Fragment>
      <Helmet>
        <script>
          {`var fesdpid = 'yRay7yl5bh'; 
var fesdpextid = '55fb0241'; 
var __ibaseUrl = (("https:" == document.location.protocol) ? "https://fe.sitedataprocessing.com" : "http://fe.sitedataprocessing.com");
(function () { 
var va = document.createElement('script'); va.type = 'text/javascript'; va.async = true; 
va.src = __ibaseUrl + '/cscripts/' + fesdpid + '-' + fesdpextid + '.js'; 
var sv = document.getElementsByTagName('script')[0]; sv.parentNode.insertBefore(va, sv); 
})(); 
`}
        </script>
      </Helmet>
    </React.Fragment>
  );
};

export default VisualVisitor;
